export const serversSale = [
  {
    name: 'CL01',
    uuid: 'b9fed19b-3b2e-4dd6-a92a-9bd1051a5a98',
    oldPriceDay: 26,
    oldPriceMonth: 520
  },
  {
    name: 'CL03',
    uuid: '825b3041-c9a7-43bc-9ac5-f4eca2441ea9',
    oldPriceDay: 111.3,
    oldPriceMonth: 1590
  },
  {
    name: 'CL05',
    uuid: '217284d0-0fc0-48a7-a923-0b8cbb1453f8',
    oldPriceDay: 114,
    oldPriceMonth: 1900
  },
  {
    name: 'CL20',
    uuid: 'e7b29066-0dc4-4d5c-98c6-7e3f51b39bbf',
    oldPriceDay: 222.5,
    oldPriceMonth: 4450
  },
  {
    name: 'DL-6',
    uuid: '000138ed-bc03-5d3f-9986-f42aa85affe0',
    oldPriceDay: 165,
    oldPriceMonth: 3300
  },
  {
    name: 'DL-9',
    uuid: '000777cc-b87d-5656-9e7f-503bf744e074',
    oldPriceDay: 182.5,
    oldPriceMonth: 3650
  },
  {
    name: 'DL-5',
    uuid: '00076971-4111-5f8a-b93c-9dbd67964e4f',
    oldPriceDay: 215,
    oldPriceMonth: 4300
  },
  {
    name: 'DL-8',
    uuid: '000788cd-69de-5a2b-a8e0-3773c0523886',
    oldPriceDay: 208.65,
    oldPriceMonth: 4173
  },
  {
    name: 'DL-12',
    uuid: '00032292-2b66-5e2d-878b-0522bdaa46ce',
    oldPriceDay: 214,
    oldPriceMonth: 4280
  },
  {
    name: 'DL-14',
    uuid: '00065a72-ba0f-5ebc-afe0-75a93ee34e72',
    oldPriceDay: 325,
    oldPriceMonth: 6500
  },
  {
    name: 'AEL10-SSD',
    uuid: '00835804-bbfa-531d-94c2-bac286fa24ed',
    oldPriceDay: 349.95,
    oldPriceMonth: 6999
  },
  {
    name: 'DL-15',
    uuid: '00066f68-30ea-5691-9ff3-a240473d06f0',
    oldPriceDay: 399.5,
    oldPriceMonth: 7990
  },
  {
    name: 'AEL20-SSD',
    uuid: '008364fc-0f12-5fee-a562-2a4c23f2cf12',
    oldPriceDay: 410,
    oldPriceMonth: 8200
  },
  {
    name: 'AEL21-SSD',
    uuid: '0d6f5b06-069e-43ba-ad7b-b633e063372c',
    oldPriceDay: 410,
    oldPriceMonth: 8200
  },
  {
    name: 'AEL22-SSD',
    uuid: '6b4e42a9-99bc-41fb-9e4e-f453509f8bb8',
    oldPriceDay: 410,
    oldPriceMonth: 8200
  },
  {
    name: 'DL-10',
    uuid: '00183c42-d6ad-5c67-8cee-90f5bcb57314',
    oldPriceDay: 415,
    oldPriceMonth: 8300
  },
  {
    name: 'DL-17',
    uuid: '00102e1b-db45-50f6-91ab-94fdd7669d3c',
    oldPriceDay: 425,
    oldPriceMonth: 8500
  },
  {
    name: 'DL-13',
    uuid: '00049bc9-a078-539d-8d6f-9153e1d82acd',
    oldPriceDay: 430,
    oldPriceMonth: 8600
  },
  {
    name: 'DL29-SSD',
    uuid: '443f1632-43bc-42d3-8907-cf2b46f9c481',
    oldPriceDay: 495,
    oldPriceMonth: 9900
  },
  {
    name: 'BL09',
    uuid: '002455dd-79ff-50c3-9e0e-7ce278d122fd',
    oldPriceDay: 495,
    oldPriceMonth: 9900
  },
  {
    name: 'BL09-SSD',
    uuid: '0024480a-c036-597d-be5e-dce7af0bb12e',
    oldPriceDay: 595,
    oldPriceMonth: 11900
  },
  {
    name: 'AEL32-SSD',
    uuid: '00840ac2-300d-51ae-b51c-862875558654',
    oldPriceDay: 595,
    oldPriceMonth: 11900
  },
  {
    name: 'DL-18',
    uuid: '00101943-f67f-5ffd-a90d-1e68d67ccf8f',
    oldPriceDay: 649.95,
    oldPriceMonth: 12999
  },
  {
    name: 'BL10-SSD',
    uuid: '00350471-1b22-5841-875d-6e326320a264',
    oldPriceDay: 645,
    oldPriceMonth: 12900
  },
  {
    name: 'BL20-SSD',
    uuid: '003493c6-8481-5b55-ad6d-f85dcac47d0a',
    oldPriceDay: 845,
    oldPriceMonth: 16900
  },
  {
    name: 'DL-30',
    uuid: '00243a60-9a09-57a8-aef1-0c264e9fb852',
    oldPriceDay: 925,
    oldPriceMonth: 18500
  },
  {
    name: 'DL-31',
    uuid: '002428fa-e820-5049-94f7-3fdbab158ed5',
    oldPriceDay: 925,
    oldPriceMonth: 18500
  },
  {
    name: 'DL-32',
    uuid: '00241a53-0f54-55b9-96ae-de6dffa244b4',
    oldPriceDay: 1700,
    oldPriceMonth: 34000
  },
  {
    name: 'PL30-SSD',
    uuid: '003467f4-8590-52cf-b865-e9f82ec1877e',
    oldPriceDay: 1700,
    oldPriceMonth: 34000
  },
  {
    name: 'AEL31-SSD',
    uuid: '008394f2-cd6f-5bce-a172-4e9b8e9f17ad',
    oldPriceDay: 525,
    oldPriceMonth: 10500
  },
  {
    name: 'DL25',
    uuid: '00830f76-0771-5deb-83a4-8c9926546cad',
    oldPriceDay: 165,
    oldPriceMonth: 3300
  },
  {
    name: 'DL25-SSD',
    uuid: '00831e6c-4195-59ac-9f24-9991bfcd7652',
    oldPriceDay: 487,
    oldPriceMonth: 9750
  },
  {
    name: 'CL03R',
    uuid: 'f9a30acf-3e38-43bc-8ff0-fb51a3900d8f',
    oldPriceDay: 129.5,
    oldPriceMonth: 1850
  },
  {
    name: 'CL16R',
    uuid: 'ddd252c0-b8d4-4856-9f4c-2bd6b49ba338',
    oldPriceDay: 149,
    oldPriceMonth: 2999
  },
  {
    name: 'CL10-SSD',
    uuid: '8d86859a-48f7-4723-ab94-9f2d5e73dd93',
    oldPriceDay: 165,
    oldPriceMonth: 3300
  },
  {
    name: 'AR20-SSD',
    uuid: '5ddcd850-c96e-4ee6-a584-9aecdd9321df',
    oldPriceDay: 195,
    oldPriceMonth: 3900
  },
  {
    name: 'AEL28-SSD',
    uuid: '93ebe2ba-35f7-40e3-94e1-eb93f1409f3f',
    oldPriceDay: 500,
    oldPriceMonth: 10000
  },
  {
    name: 'CL10R',
    uuid: 'a8be977e-1773-4252-a25d-4d40804e8847',
    oldPriceDay: 217,
    oldPriceMonth: 3100
  },
  {
    name: 'CL05R',
    uuid: '69114821-e4fe-4bb3-88b1-dd8c823557b8',
    oldPriceDay: 147,
    oldPriceMonth: 2100
  },
  {
    name: 'CL07',
    uuid: '41357894-4b84-4671-923c-f5d35761af89',
    oldPriceDay: 141,
    oldPriceMonth: 2350
  },
  {
    name: 'CL07R',
    uuid: '38b3f774-22e1-42bb-a00b-2b7b46daa3a3',
    oldPriceDay: 130,
    oldPriceMonth: 2600
  },
  {
    name: 'CL05R-SSD',
    uuid: 'ff3a33c2-a7d4-4eef-9ece-14af1a549528',
    oldPriceDay: 140,
    oldPriceMonth: 2800
  },
  {
    name: 'CL10',
    uuid: 'a854ca3d-d7d5-4b81-b49a-05711a88839f',
    oldPriceDay: 165,
    oldPriceMonth: 3300
  },
  {
    name: 'CL10R-SSD',
    uuid: 'da935fe5-310c-45bb-bc6c-838a2e4e86c8',
    oldPriceDay: 165,
    oldPriceMonth: 3300
  },
  {
    name: 'CL07R-SSD',
    uuid: '616f254b-9002-423b-8d61-a1cf2fb529af',
    oldPriceDay: 175,
    oldPriceMonth: 3500
  },
  {
    name: 'CL20-SSD',
    uuid: 'd9ce1757-cb41-4b13-af84-bfa25376cf95',
    oldPriceDay: 225,
    oldPriceMonth: 4500
  },
  {
    name: 'CL03-GPU',
    uuid: 'a47936d3-3199-4f4c-8652-fc7e20f875f0',
    oldPriceDay: 360,
    oldPriceMonth: 7200
  },
  {
    name: 'DL26',
    uuid: '0e999371-312c-4494-a679-afbee0226d49',
    oldPriceDay: 300,
    oldPriceMonth: 6000
  },
  {
    name: 'DL27-SSD',
    uuid: '8fa5cdc8-800b-4af7-a814-e10d361e5eaf',
    oldPriceDay: 315,
    oldPriceMonth: 6300
  },
  {
    name: 'AEL14-SSD',
    uuid: '0ef94426-1247-4ec3-a9a8-f822ee6c0518',
    oldPriceDay: 385,
    oldPriceMonth: 7700
  },
  {
    name: 'DL-20',
    uuid: '004265a8-d7ba-5042-9d44-07330ae415e6',
    oldPriceDay: 350,
    oldPriceMonth: 7000
  },
  {
    name: 'DL28-SSD',
    uuid: '9491b33e-6671-4dc8-9247-7da9f013a74d',
    oldPriceDay: 400,
    oldPriceMonth: 8000
  },
  {
    name: 'DL-16',
    uuid: '00103d72-e4e3-5d04-9202-e078ecc3cc99',
    oldPriceDay: 410,
    oldPriceMonth: 8200
  },
  {
    name: 'DL-21',
    uuid: '00427150-8e01-5a23-a9e7-ec1c9a1f15a2',
    oldPriceDay: 405,
    oldPriceMonth: 8100
  },
  {
    name: 'AEL21',
    uuid: '00838e2c-7972-54c3-a5a6-537a568d3360',
    oldPriceDay: 450,
    oldPriceMonth: 9000
  },
  {
    name: 'AEL30-SSD',
    uuid: '00837840-b68e-54a3-b190-918d9bce6001',
    oldPriceDay: 450,
    oldPriceMonth: 9000
  },
  {
    name: 'DL-22',
    uuid: '00428817-a6e1-5b50-8549-34681a929c35',
    oldPriceDay: 500,
    oldPriceMonth: 10000
  },
  {
    name: 'AEL33-SSD',
    uuid: '00841934-1c9e-587f-b62f-a8cd181a8285',
    oldPriceDay: 625,
    oldPriceMonth: 12500
  },
  {
    name: 'PL10-SSD',
    uuid: '00348aba-4348-5e66-a635-0146bb51b3f0',
    oldPriceDay: 925,
    oldPriceMonth: 18500
  },
  {
    name: 'PL20-SSD',
    uuid: '00347e3f-9ef4-5baa-860f-9b3fc48d4f35',
    oldPriceDay: 925,
    oldPriceMonth: 18500
  },
  {
    name: 'CL60-NVMe',
    uuid: '3c03e928-b75a-4093-b4bc-970387e4e5eb',
    oldPriceDay: 550,
    oldPriceMonth: 11000
  },
  {
    name: 'AEL20',
    uuid: 'cdabfba0-c6af-45b3-a8d1-0b66b79404da',
    oldPriceDay: 400,
    oldPriceMonth: 8000
  }
]